module.exports = __webpack_public_path__ + "media/images/svg/fb-invert-56f6c93172971dee23bf588dab653cb2.svg";